import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAttributesFunc } from "../../../store/custom-actions/attributes-actions/GetAttributesSlicer";
import { deleteAttributeFunc } from "../../../store/custom-actions/attributes-actions/DeleteAttributeSlicer";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Badge,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import PageTitle from "../../layouts/PageTitle";
import { Link } from "react-router-dom";

const AttributesPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: attributes, loading } = useSelector((state) => state.getAttributesSlicer);
  const [dropdownOpen, setDropdownOpen] = React.useState({});

  useEffect(() => {
    dispatch(getAttributesFunc());
  }, [dispatch]);

  const toggleDropdown = (id) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleDelete = (attributeId) => {
    if (window.confirm(t("Are you sure you want to delete this attribute?"))) {
      dispatch(deleteAttributeFunc(attributeId)).then(() => {
        dispatch(getAttributesFunc());
      });
    }
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle motherMenu={"Dashboard"} activeMenu={"Attributes"} />
      <Row>
        <Col>
          <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
              <h4 className="card-title mb-0">{t("Attributes")}</h4>
              <Link to="/new-attribute">
                <Button color="primary" className="btn-sm">
                  <i className="fa fa-plus me-1"></i> {t("Add New Attribute")}
                </Button>
              </Link>
            </CardHeader>
            <CardBody>
              <Row>
                {[...(attributes || [])]
                  .sort((a, b) => {
                    if (a.name.toLowerCase() == "color") return -1;
                    if (b.name.toLowerCase() == "color") return 1;
                    return a.name.localeCompare(b.name);
                  })
                  .map((attribute) => (
                    <Col key={attribute.id} lg={6} className="mb-4">
                      <Card className="h-100">
                        <CardHeader className="bg-light d-flex justify-content-between align-items-center">
                          <h5 className="card-title mb-0">{attribute.name}</h5>
                          <Dropdown isOpen={dropdownOpen[attribute.id]} toggle={() => toggleDropdown(attribute.id)}>
                            <DropdownToggle tag="span" className="btn btn-link p-2" style={{ cursor: "pointer" }}>
                              <i className="fa fa-ellipsis-v"></i>
                            </DropdownToggle>
                            <DropdownMenu end>
                              <DropdownItem tag={Link} to={`/edit-attribute/${attribute.id}`}>
                                <i className="fa fa-pencil me-2"></i> {t("Edit")}
                              </DropdownItem>
                              {attribute.name.toLowerCase() !== "color" && (
                                <DropdownItem onClick={() => handleDelete(attribute.id)}>
                                  <i className="fa fa-trash me-2"></i> {t("Delete")}
                                </DropdownItem>
                              )}
                            </DropdownMenu>
                          </Dropdown>
                        </CardHeader>
                        <CardBody>
                          <div className="d-flex flex-wrap gap-2">
                            {attribute.values.map((value) => (
                              <Badge
                                key={value.id}
                                color="light"
                                className="p-2 d-flex align-items-center"
                                style={{
                                  backgroundColor: value.hex || "#f8f9fa",
                                  color: "#212529",
                                  border: "1px solid #dee2e6",
                                }}
                              >
                                {value.value}
                              </Badge>
                            ))}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AttributesPage;
